import { c as _c } from "react/compiler-runtime";
import { SearchInput } from '@/components/inputs';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { SearchFormValues } from './hooks/useFaqSearch';
interface Props {
  initialValue: SearchFormValues['fulltext'] | undefined;
  onClean: () => void;
}
export const FIELD_FULLTEXT = 'fulltext';
export function FaqSearch(props) {
  const $ = _c(6);
  const {
    t
  } = useTranslation("faq");
  let t0;
  if ($[0] !== props.onClean || $[1] !== t) {
    t0 = fieldRenderProps => <SearchInput {...fieldRenderProps} label={t("form.searchLabel")} hideLabel={true} onClean={props.onClean} />;
    $[0] = props.onClean;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props.initialValue || $[4] !== t0) {
    t1 = <div className="relative m-auto mx-auto mt-12 w-full max-w-192 px-4 lg:mt-16 lg:px-0"><Field name={FIELD_FULLTEXT} className="lg:col-span-2" initialValue={props.initialValue}>{t0}</Field></div>;
    $[3] = props.initialValue;
    $[4] = t0;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}